import { CentraCheckoutShippingCentraOption } from "@made-people/grease-centra";
import { ShippingMethods } from "@made-people/blueprint-checkout";
import { useTranslate } from "@made-people/grease-translations";
import { MMShippingCountrySelector } from "../blueprint/checkout/MMShippingCountrySelector";
import { useExpressShippingFilter } from "../../hooks/use-auto-switch-from-express-shipping";
import { useDeliveryDataStatus } from "../../hooks/use-delivery-data-status";

export const MMCentraShippingMethodsRenderer = () => {
  const translate = useTranslate();
  const deliveryDataStatus = useDeliveryDataStatus();
  const filteredShippingMethods = useExpressShippingFilter();

  if (
    deliveryDataStatus === "loading" ||
    filteredShippingMethods.length === 0
  ) {
    return null;
  }

  const sortedShippingMethods = [...filteredShippingMethods].sort(
    (a, b) => a.priceAsNumber - b.priceAsNumber,
  );

  return (
    <ShippingMethods
      heading={{
        heading: translate("Checkout_Choose_Shipping_Method"),
      }}
    >
      <MMShippingCountrySelector />
      {sortedShippingMethods.map((method) => (
        <CentraCheckoutShippingCentraOption
          method={method}
          key={method.shippingMethod}
        />
      ))}
    </ShippingMethods>
  );
};
